module.exports = __webpack_public_path__ + "img/banner_icon4.2d586b58.png";